import * as tslib_1 from "tslib";
import { css } from '../../styles';
var PX_VALUE_REGEXP = /^\d+.*&/g;
function formatPxValue(value) {
    return typeof value === 'number' ? value + "px" : value;
}
var isPxValue = function (value) {
    return typeof value === 'number' ||
        (typeof value === 'string' && PX_VALUE_REGEXP.test(value));
};
var paddingPropReceiver = function (props) { return css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ",
    ";\n  ",
    ";\n  ", ";\n  ",
    ";\n  ",
    ";\n  ",
    ";\n  ",
    ";\n"])), isPxValue(props.paddingHorizontal) &&
    "padding-left: " + formatPxValue(props.paddingHorizontal) + "; padding-right: " + formatPxValue(props.paddingHorizontal) + ";", isPxValue(props.paddingVertical) &&
    "padding-top: " + formatPxValue(props.paddingVertical) + "; padding-bottom: " + formatPxValue(props.paddingVertical) + ";", isPxValue(props.padding) && "padding: " + formatPxValue(props.padding), isPxValue(props.paddingTop) &&
    "padding-top: " + formatPxValue(props.paddingTop) + ";", isPxValue(props.paddingBottom) &&
    "padding-bottom: " + formatPxValue(props.paddingBottom) + ";", isPxValue(props.paddingLeft) &&
    "padding-left: " + formatPxValue(props.paddingLeft) + ";", isPxValue(props.paddingRight) &&
    "padding-right: " + formatPxValue(props.paddingRight) + ";"); };
export default paddingPropReceiver;
var templateObject_1;
//# sourceMappingURL=padding.js.map